module.exports = {
  baseUrl: 'https://www.checkcheck.me',
  languageSwitch: 'Languages',
  'languageSwitch-tw': '繁體中文',
  'languageSwitch-en': 'English',
  'languageSwitch-ja': '日本語',
  'languageSwitch-th': 'ภาษาไทย',
  gogolookOfficialWebsite: 'https://gogolook.com',
};
